import { combineReducers } from 'redux'

// -- ACCOUNT
import { account } from './account'

// -- GLOBAL ATTRIBUTES
import {
  globalResources,
  globalVariables,
  globalProducts,
  globalLocations,
  globalWeathers,
  globalParameters
} from './globals'

// -- PROJECT + its ATTRIBUTES
import {
  projects,
  projectVariables,
  projectResources,
  projectProducts,
  projectLocations,
  projectWeathers,
  projectParameters
} from './projects'

// -- PROJECT + its ATTRIBUTES
import {
  scenarios,
  scenarioVariables,
  scenarioResources,
  scenarioProducts,
  scenarioLocations,
  scenarioWeathers,
  scenarioParameters
} from './scenarios'

// -- FLOW GROUP + its ATTRIBUTES
import { flowGroups, flowGroupElements, flowGroupBpmnState } from './flowGroups'

// -- FLOW ACTIONS
import {
  flowStart,
  flowConditions,
  flowConditionChecks,
  flowTasks,
  flowTaskInteractionVariables,
  flowTaskInteractionResources,
  flowTaskInteractionChecks,
  flowEnd
} from './flowActions'

// -- ALPHA FACTORS
import { alphaFactors } from './alphaFactors'

// -- SIMULATIONS
import { simulations } from './simulations'

// ============================================================

export const reducers = combineReducers({
  // -- ACCOUNT
  account,

  // -- GLOBAL ATTRIBUTES
  globalResources,
  globalVariables,
  globalProducts,
  globalLocations,
  globalWeathers,
  globalParameters,

  // -- PROJECT + its ATTRIBUTES
  projects,
  projectVariables,
  projectResources,
  projectProducts,
  projectLocations,
  projectWeathers,
  projectParameters,

  // -- SCENARIOS + its ATTRIBUTES
  scenarios,
  scenarioVariables,
  scenarioResources,
  scenarioProducts,
  scenarioLocations,
  scenarioWeathers,
  scenarioParameters,

  // -- FLOW GROUPS
  flowGroups,
  flowGroupElements,
  flowGroupBpmnState,
  // -- FLOW ACTIONS
  flowStart,
  flowConditions,
  flowConditionChecks,
  flowTasks,
  flowTaskInteractionVariables,
  flowTaskInteractionResources,
  flowTaskInteractionChecks,
  flowEnd,
  // -- ALPHA FACTORS
  alphaFactors,

  // -- SIMULATIONS
  simulations
})
